import React from 'react';
import './ErrorMessage.css';
import { useTranslation } from '../hooks/useTranslation';

interface ErrorMessageProps {
  message: string;
  title?: string;
  onRetry?: () => void;
  fullscreen?: boolean;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ 
  message, 
  title,
  onRetry,
  fullscreen = false 
}) => {
  const { t } = useTranslation();
  const displayTitle = title || t('error.generic');
  
  return (
    <div className={`error-container ${fullscreen ? 'error-fullscreen' : 'error-inline'}`}>
      <div className="error-icon">⚠️</div>
      <h2 className="error-title">{displayTitle}</h2>
      <p className="error-message">{message}</p>
      {onRetry && (
        <button onClick={onRetry} className="error-retry-button">
          {t('error.tryAgain')}
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;
